var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08732 2.69109L0.980467 3.00811C0.907817 3.02131 0.85498 3.08075 0.85498 3.15341C0.85498 3.19303 0.86819 3.23266 0.894608 3.25908L2.42687 4.83097L2.06362 7.03029C2.06362 7.03689 2.06362 7.0435 2.06362 7.0567C2.06362 7.13596 2.12966 7.202 2.20892 7.202C2.24194 7.202 2.26175 7.1954 2.28817 7.18219L4.17047 6.15188L6.04617 7.18219C6.06598 7.1954 6.0924 7.202 6.11882 7.202C6.19808 7.202 6.26412 7.13596 6.26412 7.0567C6.26412 7.0435 6.26412 7.03689 6.26412 7.03029L5.90087 4.83097L7.43313 3.25908C7.45955 3.23266 7.47276 3.19303 7.47276 3.15341C7.47276 3.08075 7.41992 3.02131 7.35388 3.00811H7.34727L5.24041 2.69109L4.26294 0.650274C4.24312 0.610647 4.2035 0.584229 4.15726 0.584229C4.11103 0.584229 4.07141 0.610647 4.05159 0.650274L3.08732 2.69109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.24afaef9b1fb9615ec250d59cd26b356.svg";
export { ForwardRef as ReactComponent };